// extracted by mini-css-extract-plugin
export default {"component":"vuacd","partner-logo":"K5vV4"};